import { UserLobby } from '../../types/requests/responses/request-response'
import { UserResponse } from '../../types/users/user-response'
import { LobbyMemberTypeEnum } from '../enums/lobby-member-type.enum'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import utc from 'dayjs/plugin/utc'

dayjs.extend(isBetween)
dayjs.extend(utc)

export function parseTeammates(userLobbies?: UserLobby[]): UserResponse[] {
  if (!userLobbies) {
    return []
  }

  return userLobbies
    ?.filter((userLobby) => {
      return userLobby.type === LobbyMemberTypeEnum.TEAMMATE
    })
    ?.map((userLobby) => {
      return userLobby.user
    })
}

export function parseUsers(userLobbies?: UserLobby[]): UserResponse[] {
  if (!userLobbies) {
    return []
  }

  return userLobbies?.map((userLobby) => {
    return userLobby.user
  })
}
